import { computed } from 'mobx';

/**
 * 모델
 * @window w_tb_e030_new
 * @category 점검기종등록
 */

export class InspectionTypeModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 종류코드
   *
   * **data type** varchar(5)
   */
  evcd: string;

  /**
   * 종류명
   *
   * **data type** varchar(100)
   */
  evnm: string;

  /**
   * 사용유무
   *
   * **data type** char(1)
   */
  useyn: string;

  /**
   * 적용일
   *
   * **data type** char(8)
   */
  evdate: string;

  /**
   * 비고
   *
   * **data type** varchar(255)
   */
  remark: string;

  /**
   * 정보형식코드
   *
   * **data type** varchar(5)
   */
  CHK_NUM: string;

  /**
   * 정보센터
   *
   * **data type** varchar(10)
   */
  SEL_CHK_ITEM_CD: string;

  /**
   * 비고
   *
   * **data type** varchar(10)
   */
  UP_SEK_CHK_ITEM_CD: string;

  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.evcd = data.evcd || '';
    this.evnm = data.evnm || '';
    this.evdate = data.evdate || '';
    this.useyn = data.useyn || '';
    this.remark = data.remark || '';
    this.CHK_NUM = data.CHK_NUM || '';
    this.SEL_CHK_ITEM_CD = data.SEL_CHK_ITEM_CD || '';
    this.UP_SEK_CHK_ITEM_CD = data.UP_SEK_CHK_ITEM_CD || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
